import { AxiosClient } from "../../utils/axios";
import { logError } from "../../utils/logError";
export const state = () => ({
  listLiveStream: [],
  loading:false,
  config:null,
  schedule:null,
  livestreamConnectionList:[]
});

export const mutations = {
  SET_LIST_LIVESTREAM(state, payload) {
    state.listLiveStream = payload;
  },
  SET_LIVESTREAM_CONNECTION_LIST(state,payload){
state.livestreamConnectionList = payload
  },
  SET_SCHEDULE(state,payload){
    state.schedule = payload
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_LIVESTREAM_SELECTED(state, payload) {
    state.liveStreamSelected = payload;
  },
  SET_ROLE(state, payload) {
    state.role = payload;
  },
  SET_CONFIG(state, payload) {
    state.config = payload;
  },


};

export const actions = {
  async createSchedule(state,payload){
    const {member_id,
      school_id,
      title,
      description,
      stream_register_date,
      stream_register_time} = payload 
    try {
      state.commit('SET_LOADING',true)
      const res = await AxiosClient.post(`/eduzone/api/livestream/schedule/create`,{
      member_id,
      school_id,
      title,
      description,
      stream_register_date,
      stream_register_time
      });
      // if(res?.data?.data){
      //   state.commit('SET_CONFIG',res?.data?.data)
      // }
      state.commit('SET_LOADING',false)

      return {
        success:true,
        data:res.data
      }
    } catch (error) {
      logError(error,'createSchedule on store')
      state.commit('SET_LOADING',false)
      return {
        success:false,
        error
      }
    }
  },
  async getListSchedule(state,payload){
    const {
      school_id,
   } = payload 
    try {
      state.commit('SET_LOADING',true)
      const res = await AxiosClient.post(`/eduzone/api/livestream/schedule/get`,{
 
      school_id,
 
      });
      // if(res?.data?.data){
      //   state.commit('SET_CONFIG',res?.data?.data)
      // }
      state.commit('SET_LOADING',false)

      return {
        success:true,
        data:res.data
      }
    } catch (error) {
      logError(error,'getSchedule on store')
      state.commit('SET_LOADING',false)
      return {
        success:false,
        error
      }
    }
  },
  async editSchedule(state,payload){
    const {    id,
      school_id,
      member_id,
      title,
      description,
      stream_register_date,
      stream_register_time} = payload 
    try {
      state.commit('SET_LOADING',true)
      const res = await AxiosClient.post(`/eduzone/api/livestream/schedule/edit`,{
        id,
      school_id,
      member_id,
      title,
      description,
      stream_register_date,
      stream_register_time
      });
      // if(res?.data?.data){
      //   state.commit('SET_CONFIG',res?.data?.data)
      // }
      state.commit('SET_LOADING',false)

      return {
        success:true,
        data:res.data
      }
    } catch (error) {
      logError(error,' on store')
      state.commit('SET_LOADING',false)
      return {
        success:false,
        error
      }
    }
  },
  async deleteSchedule(state,payload){
    const {id,member_id,school_id} = payload 
    try {
      state.commit('SET_LOADING',true)
      const res = await AxiosClient.post(`/eduzone/api/livestream/schedule/delete`,{
      id,
      member_id,
      school_id
      });
      // if(res?.data?.data){
      //   state.commit('SET_CONFIG',res?.data?.data)
      // }
      state.commit('SET_LOADING',false)

      return {
        success:true,
        data:res.data
      }
    } catch (error) {
      logError(error,'delete on store')
      state.commit('SET_LOADING',false)
      return {
        success:false,
        error
      }
    }
  },
 

  async startLiveStream(state,payload){
    try {
      state.commit('SET_LOADING',true)
      const res = await AxiosClient.post(`/eduzone/api/livestream/start`,{
      school_id:payload.school_id
      });
      if(res?.data?.data && res?.data?.data?.ChannelARN){
        state.commit('SET_CONFIG',res?.data?.data)
      }
      state.commit('SET_LOADING',false)

      return {
        success:true,
        data:res.data?.data
      }
    } catch (error) {
      logError(error,'startLiveStream on store')
      state.commit('SET_LOADING',false)
      return {
        success:false,
        error
      }
    }
  },

  async viewLiveStream(state,payload){
    try {
      state.commit('SET_LOADING',true)
      const res = await AxiosClient.post(`/eduzone/api/livestream/view`,{
        school_id:payload.school_id
        });
        
        if(res?.data?.data){
          state.commit('SET_CONFIG',res?.data?.data)
        }
        state.commit('SET_LOADING',false)
        return {
          success:true,
          data:res?.data?.data
        }
    } catch (error) {
      logError(error,'viewLiveStream on store')
      state.commit('SET_LOADING',false)
      return {
        success:false,
        error
      }
    }
  },

  async endLiveStream(state,payload){
    try {
      state.commit('SET_LOADING',true)
      const res = await AxiosClient.post(`/eduzone/api/livestream/end`,{
        school_id:payload.school_id
        });
        state.commit('SET_LOADING',false)
      return {
        success:true,
        data:res.data
      }
    } catch (error) {
      logError(error,'endLiveStream on store')
      state.commit('SET_LOADING',false)
      return {
        success:false,
        error
      }
    }
  }

};
